<template>
  <div>
    <v-btn
      class="pa-3"
      fab
      :color="myPlanX ? 'green' : 'yellow'"
      @click="myPlanX ? (myPlanDialog = true) : (subscriptionDialog = true)"
    >
      <v-icon :color="myPlanX ? 'white' : 'black'"> mdi-crown </v-icon>
    </v-btn>
    <ApiErrorDialog v-if="api.isError" :api="api" />
    <SubscriptionDialog
      v-if="subscriptionDialog"
      :callbackClose="() => (subscriptionDialog = false)"
      :showDialog="true"
    />
    <MyPlanDialog
      v-if="myPlanDialog"
      :callbackClose="() => (myPlanDialog = false)"
      :showDialog="true"
      :myPlan="myPlanX.Plan"
    />
  </div>
</template>
    
<script>
import { mapState } from "vuex";
export default {
  components: {
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    SubscriptionDialog: () =>
      import(
        /* webpackChunkName: "component-subscription-dialog" */ "@/components/SubscriptionDialog"
      ),
    MyPlanDialog: () =>
      import(
        /* webpackChunkName: "my-plan-dialog" */ "@/components/MyPlanDialog"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    subscriptionDialog: false,
    myPlanDialog: false,
    myPlanX: null,
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  created() {
    //
  },
  async mounted() {
    await this.myPlan();
  },
  methods: {
    async myPlan() {
      this.api.method = "get";
      this.api.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/player/myPlan";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error(e);
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.myPlanX = resp.Plan;
      };
      await this.$api.fetch(this.api);
    },
  },
};
</script>